import React, { useEffect, useState } from 'react';
import {
  RiCheckboxCircleLine,
  RiCheckboxBlankCircleLine,
} from 'react-icons/ri';

const FastBooking = ({ value = [], onChoose }) => {
  useEffect(() => {
    if (value.includes('46')) {
      setChecked(true);
    } else setChecked(false);
  }, [value]);
  const [checked, setChecked] = useState(false);
  return (
    <div className={`search-widget widget-checkbox ${checked}`}>
      <label>
        <span>Мгновенное подтверждение</span>
        <input
          style={{ display: 'none' }}
          type="checkbox"
          defaultChecked={checked}
          onClick={() => {
            const index = value.indexOf('46');

            if (index !== -1) {
              onChoose(value.toSpliced(index, 1));
            } else {
              onChoose([...value, '46']);
            }
            // setChecked(!checked);
          }}
        />
        {checked ? (
          <RiCheckboxCircleLine
            style={{
              fontSize: '20px',
              color: '#48693f',
            }}
          />
        ) : (
          <RiCheckboxBlankCircleLine
            style={{
              fontSize: '20px',
              color: '#48693f',
            }}
          />
        )}
      </label>
    </div>
  );
};
export default FastBooking;
